import type { Variation } from '~/types'

import useGetInStockAmount from '../orders-and-receives/order-item-receipts/hooks/useGetInStockAmount'

const ReOrderQuantityCell = (item: Variation) => {
  const getInStockAmount = useGetInStockAmount()

  return getInStockAmount({
    amount: item.reorderQuantity,
    amountUnitsId: item.reorderQuantityUnitId,
    perPackageUnitsId: item.perPackageUnitsId,
    packageTypeId: item.packageTypeId,
  })
}

export default ReOrderQuantityCell
